import controlDate from './index.js';

const SET_LOADING = (state, loading) => {
  state.loading = loading;
};

const SET_PROVIDERS = (state, providers) => {
  state.cmsProviders = providers;
};

const SET_SEARCH = (state, search) => {
  state.search = search;
}

const SET_TOTAL_PAGES = (state, totalPages) => {
  state.totalPages = totalPages;
}

const SET_CURRENT_PAGE = (state, currentPage) => {
  state.currentPage= currentPage;
}

const SET_TOTAL_PROVIDERS = (state, totalProducts) => {
  state.totalProducts = totalProducts
}

const INVALIDATE = (state) => {
  state.outDated= true;
}


export default {
  SET_LOADING,
  SET_PROVIDERS,
  SET_SEARCH,
  SET_TOTAL_PROVIDERS,
  SET_CURRENT_PAGE,
  SET_TOTAL_PAGES,
  INVALIDATE
};
